const AppHeaderCenter = () => {
  return <div className='min-w-[1rem] md:min-w-[2rem] lg:min-w-[4rem]' data-sentry-component="AppHeaderCenter" data-sentry-source-file="AppHeaderCenter.tsx">
      <span className='block h-px w-full' />
    </div>;
};
export default AppHeaderCenter;